export default {
  apiUrl:
    process.env.VUE_APP_MODE === 'local'
      ? 'http://localhost:8000/api/'
      : 'https://vintage-and-art.com/api/'
}
